
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

const clamp = (min, max, v) => Math.min(Math.max(v, min), max);

export { clamp };
//# sourceMappingURL=clamp.mjs.js.map
